export const STUDIO = {
  name: "PLENA STUDIO",
  product: "SNAP",
  presents: "PLENA STUDIO presents SNAP",
  mark: "PLENA SNAP",
};
